import { atom } from "recoil";
import { AuthUser } from "../../types";

export const contextSignInUserAtom = atom<AuthUser | null>({
  key: "contextSignInUserAtom",
  default: null,
});
